import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as businessPaymentRunState from '../reducers';
import * as businessPaymentRunReducer from '../reducers/business-payment-run.reducer';

export const selectBusinessPaymentRun = createSelector(
  businessPaymentRunState.selectBusinessPaymentRunState,
  businessPaymentRunReducer.getBusinessPaymentRun
);
